module.exports = __webpack_public_path__ + "img/바운티헌터.8e7197ce.png";